import angular from 'angular';
import invoicesComponent from './invoices.component';

let invoicesModule = angular.module('invoices', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('invoices', invoicesComponent);

export default invoicesModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoices/invoices.js